import { connect } from "react-redux"
import React, { useState, useEffect } from "react"
import { faArrowUpFromBracket, faCheck, faInfoCircle } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faClock } from "@fortawesome/free-regular-svg-icons"
import {
  faCalendarCheck,
  faCircleInfo,
  faEnvelope,
  faPhone,
  faXmark
} from "@fortawesome/pro-regular-svg-icons"
import { faCalendarDay } from "@fortawesome/pro-regular-svg-icons/faCalendarDay"
import { Loader, Modal, Select, Button, Input } from "semantic-ui-react"
import { formatTime, formatDate } from "../../helpers/dateHelpers"
import { navigationPaths } from "../../constants/paths"
import { TiresBottomNav } from "../../layouts/TiresLayout"
import { gaJSON, trackFirebaseAnalytics } from "../../helpers/googleAnalyticsHelpers"
import AddToCalendarButton from "../../components/shared/AddToCalendarButton"
import moment from "moment"
import { SUCCESS, TIRE_CONNECT_INSTALLATION } from "../../constants/tires"
import { numberFormatToCurrency } from "../../components/tires/currency"

const TireOrderConfirmed = ({ dispatch, match, history, user }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [isInstructionsModalOpen, setIsInstructionsModalOpen] = useState(false)
  const [selectedContact, setSelectedContact] = useState(null)
  const [selectedPhoneNumber, setSelectedPhoneNumber] = useState("")
  const [selectedFormattedPhoneNumber, setselectedFormattedPhoneNumber] = useState("")
  const [fleetUsers, setFleetUsers] = useState([])
  const [order, setOrder] = useState(null)
  const [isSmsSending, setIsSmsSending] = useState(false)
  const [isSmsSentSuccess, setIsSmsSentSuccess] = useState(false)
  const [error, setError] = useState("")
  const [userId, setUserId] = useState(null)
  const [event, setEvent] = useState(null)
  const [tireDetails, setTireDetails] = useState(null)

  useEffect(() => {
    setIsLoading(true)
    dispatch({
      type: "TIRE_ORDER_DETAILS_SAGA",
      payload: match.params.id,
      callback: (res, data) => {
        if (data.fleet_tire_shop_order) {
          setOrder(data.fleet_tire_shop_order)

          loadUsers()
          loadTireDetails(data?.fleet_tire_shop_order?.tire_orders[0]?.tire_id)
        }
        setIsLoading(false)
      }
    })
  }, [])

  const installationOrder = order?.order_services?.find(
    (service) => service.name === TIRE_CONNECT_INSTALLATION
  )

  const loadTireDetails = (tireId) => {
    if (tireId) {
      setIsLoading(true)

      dispatch({
        type: "GET_TIRES_DETAILS_BY_ID_SAGA",
        payload: tireId,
        callback: (status, data) => {
          if (status === SUCCESS) {
            setTireDetails(data?.tire?.data)
          }
          setIsLoading(false)
        }
      })
    }
  }

  const loadUsers = () => {
    dispatch({
      type: "USERS_LOAD_SAGA",
      callback: (text, data) => {
        setFleetUsers(data)
      }
    })
  }

  const sendSms = () => {
    setError("")
    setIsSmsSending(true)
    dispatch({
      type: "SEND_INSTRUCTIONS_SMS",
      payload: {
        user_id: userId,
        phone_number: "+1" + selectedPhoneNumber,
        order_id: order?.id
      },
      callback: (text, data) => {
        if (data?.success) {
          setIsSmsSentSuccess(true)
        } else {
          setError(data?.error)
        }
        setIsSmsSending(false)
      }
    })
  }

  const openInstructionsLinkClick = () => {
    setIsInstructionsModalOpen(true)
  }

  const closeInstructionsModal = () => {
    setSelectedContact(null)
    setSelectedPhoneNumber("")
    setIsInstructionsModalOpen(false)
  }

  const handleContact = (e, { value, options }) => {
    setSelectedContact(value)
    setError("")
    setIsSmsSentSuccess(false)
    const user = options.find((option) => option.value === value)
    setUserId(user?.key)
    if (/^\d{0,10}$/.test(user.phone)) {
      setSelectedPhoneNumber(user.phone)
    }
  }

  const handlePhoneNumber = (data) => {
    const formatted = formatPhoneNumber(data.value)
    setSelectedPhoneNumber(data.value)
    setselectedFormattedPhoneNumber(formatted)
    setError("")
  }

  function formatPhoneNumber(value) {
    const digits = value.replace(/\D/g, "")
    const cleaned = digits.slice(0, 10)
    const part1 = cleaned.slice(0, 3)
    const part2 = cleaned.slice(3, 6)
    const part3 = cleaned.slice(6, 10)
    if (cleaned.length <= 3) return part1
    if (cleaned.length <= 6) return `(${part1}) ${part2}`
    return `(${part1}) ${part2}-${part3}`
  }

  const contacts = fleetUsers
    ?.filter((user) => user?.is_active)
    ?.map((user) => ({
      key: String(user?.id),
      value: user?.name,
      text: user?.name,
      phone: user?.cellPhone
    }))
    ?.sort((a, b) => a.text.localeCompare(b.text))

  useEffect(() => {
    buildEvent()
  }, [order])

  const buildEvent = () => {
    const shop = order?.shop
    const start = moment(order?.appointment_datetime)
    const end = start.clone().add(1, "hour")
    const duration = end.diff(start, "hours")
    const description = `${shop?.name} ${shop?.address_line1} ${shop?.city}, ${shop?.state} ${shop?.zip}`

    let eventFormed = {
      title: `CarAdvise Appointment - ${shop?.name}`,
      startDate: start.format("YYYY-MM-DD"),
      startTime: start.format("HH:mm"),
      endDate: end.format("YYYY-MM-DD"),
      endTime: end.format("HH:mm"),
      timezone: shop?.timezone,
      duration: `${duration}`,
      description: description,
      location: `${shop?.address_line1} ${shop?.city}, ${shop?.state} ${shop?.zip}`,
      iCalFileName: `CarAdvise Appointment - ${shop?.name}`
    }
    setEvent(eventFormed)
  }

  const InstructionsModal = () => {
    return (
      <Modal
        onClose={() => closeInstructionsModal()}
        open={isInstructionsModalOpen}
        className="max-w-[600px] mx-auto p-[10px]"
      >
        <div className="flex flex-row justify-between items-start pb-[10px]">
          <b className="text-lg">Share appointment instructions</b>
          <button onClick={() => closeInstructionsModal()}>
            <FontAwesomeIcon icon={faXmark} style={{ height: "16px", width: "16px" }} />
          </button>
        </div>
        <b>1. Share via text message:</b>
        <p className="pt-[10px]">
          We'll text the person arriving at the appointment with instructions to share with the
          shop. Please select the correct contact below:
        </p>
        <Select options={contacts} placeholder="Select Contact" onChange={handleContact} fluid />
        {selectedContact && (
          <>
            <div className="flex flex-row p-[10px] mt-[10px] bg-[#FEF3C7] rounded-lg">
              <FontAwesomeIcon icon={faInfoCircle} className="pr-[10px]" />
              <p className="text-[#3C3C3C]">
                <b>Please confirm or enter the phone number of the selected contact.</b> We'll save
                this number to their profile for future use.
              </p>
            </div>
            <div className="flex flex-row mt-[10px] gap-1">
              <p className="m-0" style={{ color: error ? "#B91C1C" : null }}>
                Mobile Phone Number
              </p>
              <p style={{ color: "red" }}> *</p>
            </div>
            <Input
              className="w-full"
              value={selectedFormattedPhoneNumber}
              onChange={(e, data) => handlePhoneNumber(data)}
              error={error !== ""}
              placeholder="(XXX) XXX-XXXX"
            />
            {error && (
              <div className="p-[5px]" style={{ backgroundColor: "#FEF2F2" }}>
                <p style={{ color: "#B91C1C" }}>{error}</p>
              </div>
            )}
          </>
        )}
        <Button
          className={"w-full " + (isSmsSentSuccess ? "pale-green-btn" : "navy-blue-btn")}
          style={{
            marginTop: "10px"
          }}
          disabled={!selectedContact || selectedPhoneNumber?.length !== 10}
          onClick={(e, data) => (isSmsSentSuccess ? null : sendSms(data))}
          loading={isSmsSending}
        >
          <Button.Content>
            <div className="flex flex-row justify-center items-center">
              <p className={"m-0 " + (isSmsSentSuccess ? "success-text" : "confirm-text")}>
                {isSmsSentSuccess ? "Text message sent" : "Confirm phone and send text"}
              </p>
              {isSmsSentSuccess && (
                <FontAwesomeIcon icon={faCheck} className="pl-[10px]" color="#064E3B" />
              )}
            </div>
          </Button.Content>
        </Button>
        <div className="flex flex-row" style={{ alignItems: "center" }}>
          <hr className="w-full" style={{ color: "#E0E0E0" }} />{" "}
          <p className="m-0 p-5" style={{ color: "#7F7F7F" }}>
            or
          </p>{" "}
          <hr className="w-full" style={{ color: "#E0E0E0" }} />
        </div>
        <b>2. Print instructions to share with the person attending the appointment:</b>
        <Button
          className="w-full"
          style={{ marginTop: "10px" }}
          onClick={() => {
            trackFirebaseAnalytics({
              event: gaJSON.instructions_downloaded,
              params: {
                vehicle_id: order?.vehicle?.id,
                user_role: user?.roles?.toString()
              }
            })
            history.push(navigationPaths.tireInstallDetails(order.id))
          }}
        >
          Print instructions
        </Button>
      </Modal>
    )
  }

  if (isLoading) {
    return (
      <div className="confirmation-container flex m-auto justify-center">
        <Loader active inline="centered" size="large" />
      </div>
    )
  }

  let tireOrderDetails
  if (tireDetails) {
    tireOrderDetails = tireDetails
  } else {
    tireOrderDetails = order?.tire_orders[0]
  }

  return (
    <>
      {InstructionsModal()}
      <div className="max-w-[650px] mx-auto mt-5 px-[10px] mb-[100px]">
        <div className="bg-white text-black rounded-lg shadow">
          <div className="flex flex-row justify-between w-full bg-[#F9F9F9] p-6 rounded-t-lg">
            <div>
              <p className="font-bold text-black text-xl m-0">
                Your Appointment and Tire Order Are Confirmed!
              </p>
              <p
                className="text-lg pt-[5px] underline flex flex-row gap-2 text-black"
                onClick={() => openInstructionsLinkClick()}
              >
                <FontAwesomeIcon icon={faArrowUpFromBracket} className="text-black" />
                Share appointment instructions
              </p>
            </div>
            <div>
              <p className="rounded-xl px-2 py-1 bg-[#F6BFB1] text-black font-bold text-sm">
                Order ID: {match.params.id}
              </p>
            </div>
          </div>
          <div className="p-6">
            <div>
              <p className="font-bold text-lg">Vehicle</p>
              <div className="flex flex-row gap-5 align-items-center">
                <img className="h-15" src={order?.vehicle?.images[0]?.url} />
                <div className="flex flex-col justify-center">
                  <p className="font-bold m-0">
                    {order?.vehicle?.year} {order?.vehicle?.make} {order?.vehicle?.model}
                  </p>
                  <p className="font-light text-sm">VIN: {order?.vehicle?.vin}</p>
                </div>
              </div>
            </div>
            <hr className="my-5 text-gray-200" />
            <div>
              <p className="font-bold text-lg">Tire details</p>
              <div className="flex flex-row gap-5 justify-between">
                <div className="flex flex-row gap-10">
                  <img
                    src={
                      tireDetails?.image
                        ? tireDetails?.image
                        : "https://devdemo.tireconnect.ca/uploads/tires/pre_up/1/Goodyear/images/gy_assurance_fuel_max_l.jpg"
                    }
                    className="h-30 pl-5"
                  />
                  <div>
                    <p className="font-bold text-lg m-0 pb-3">
                      {tireDetails?.brand || order?.tire_orders[0].brand}{" "}
                      {tireDetails?.model || order?.tire_orders[0].tire_model}
                    </p>
                    <p className="m-0">{tireDetails?.size || order?.tire_orders[0].tire_details}</p>
                    <div className="flex flex-row gap-5 text-sm my-2">
                      {tireOrderDetails && (
                        <>
                          <p className="m-0">
                            Run flat:{" "}
                            <span className="font-bold">
                              {tireOrderDetails?.run_flat ? "Yes" : "No"}
                            </span>
                          </p>
                          <p className="m-0">
                            Load range:{" "}
                            <span className="font-bold">
                              {tireOrderDetails?.load_range ?? tireOrderDetails?.load_index}
                            </span>
                          </p>
                          <p className="m-0">
                            Speed rating:{" "}
                            <span className="font-bold">{tireOrderDetails.speed_rating}</span>
                          </p>
                        </>
                      )}
                    </div>
                    <div className="text-sm flex-col">
                      <p className="text-sm m-0">
                        <span className="font-bold">Quantity: </span>{" "}
                        <span className="text-black">{order?.tire_orders[0].quantity}</span>
                      </p>

                      {order?.tire_orders[0].price &&
                        `$${
                          order?.tire_orders[0]?.total_price / order?.tire_orders[0]?.quantity
                        } / tire`}
                    </div>
                  </div>
                </div>
                <p className="font-bold text-lg">
                  {numberFormatToCurrency(
                    tireOrderDetails?.quantity * tireOrderDetails?.retail_price
                  )}
                </p>
              </div>
              <div className="flex flex-row gap-3 bg-amber-100 rounded-xl p-2 mt-5">
                <FontAwesomeIcon icon={faClock} className="mt-1" />
                <p className="text-sm">
                  We estimate your tires will be delivered to the shop before your install
                  appointment; however, we recommend calling the number below to confirm delivery
                  before arriving, in case of any delays.
                </p>
              </div>
            </div>
            <hr className="my-5 text-gray-200" />
            <div>
              <div
                style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}
              >
                <p className="font-bold text-lg">Install appointment details</p>
                <p className="font-bold text-lg">{installationOrder?.total}</p>
              </div>
              <div className="flex flex-row justify-between">
                <p>Taxes</p>
                <p className="font-bold">{order?.tax ?? "$0.00"}</p>
              </div>
              <div className="flex flex-row justify-between">
                <p>Convenience fee</p>
                <p className="margin-0 font-bold">{order?.transaction_fee ?? "$0.00"}</p>
              </div>
              {tireOrderDetails?.delivery_fee && (
                <div className="flex flex-row justify-between">
                  <p>Delivery fee</p>
                  <p className="margin-0 font-bold">
                    ${Number(tireOrderDetails?.delivery_fee).toFixed(2) ?? "$0.00"}
                  </p>
                </div>
              )}
              <div className="flex flex-row justify-between">
                <p className="margin-0 font-bold font-18">Order Total</p>
                <p className="margin-0 font-bold">{order?.total ?? "$0.00"}</p>
              </div>
              <div className="flex flex-row justify-between items-start">
                <div>
                  <p className="font-semibold m-0">{order?.shop?.name}</p>
                  <p className="m-0 py-1">{order?.shop.address_line1}</p>
                  <p className="m-0 py-1">
                    {order?.shop.city}, {order?.shop.state} {order?.shop.zip}
                  </p>
                  {order?.shop?.phone && (
                    <p className="m-0 py-1">
                      <FontAwesomeIcon icon={faPhone} className="mr-1" />
                      {order.shop.phone}
                    </p>
                  )}
                </div>
              </div>
              <div className="mt-4 flex flex-row items-center gap-2">
                <p className="appointment-date m-0 ">
                  {" "}
                  <FontAwesomeIcon icon={faCalendarDay} />{" "}
                  {formatDate(order?.appointment_datetime_in_iso)} |{" "}
                  {formatTime(order?.appointment_datetime_in_iso)}
                </p>
                <p className="px-2 py-1 rounded-2xl bg-gray-100 text-sm">
                  {" "}
                  <FontAwesomeIcon icon={faCalendarCheck} className="mr-1" />{" "}
                  <AddToCalendarButton {...event} />
                </p>
              </div>
              <div className="flex flex-row gap-3 bg-gray-100 rounded-xl p-2 mt-5">
                <FontAwesomeIcon icon={faCircleInfo} className="mt-1" />
                <p className="text-sm">
                  You can view this appointment at any time under the "Active Orders" tab on your
                  Services page. To reschedule or make changes, please call us at the number below.
                </p>
              </div>
            </div>
            <hr className="my-5 text-gray-200" />
            <div>
              <p className="font-bold text-lg">
                Questions or concerns?{" "}
                <span className="font-normal text-xl">Our support team is here to help!</span>
              </p>
              <p>
                <FontAwesomeIcon icon={faEnvelope} className="mr-2 appointment-date" />
                support@caradvise.com
              </p>
              <p>
                <FontAwesomeIcon icon={faPhone} className="mr-1 appointment-date" /> (844) 923-8473
              </p>
            </div>
          </div>
        </div>
      </div>

      <TiresBottomNav
        nextBtnText="Go to Dashboard"
        nextDisabled={true}
        next={() => {
          trackFirebaseAnalytics({
            event: gaJSON.dashboard_redirect_clicked,
            params: {
              vehicle_id: order.vehicle?.id,
              user_role: user?.roles?.toString(),
              order_id: order?.id
            }
          })
          history.push("/dashboard")
        }}
        showBackBtn={false}
      />
    </>
  )
}

function mapStateToProps(state) {
  const user = state.application.userSessionData || (state.users && state.users.currentUser)
  return {
    user: user
  }
}

export default connect(mapStateToProps)(TireOrderConfirmed)
